import type { dashboardProfile } from '@/mocks/dashboard';
import SAR from '@/components/feature/SAR';

interface DashboardStatsProps {
  profile: typeof dashboardProfile;
}

const DashboardStats = ({ profile }: DashboardStatsProps) => {
  const fmt = (n: number) =>
    new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n);

  const cards = [
    {
      label: 'إجمالي المبالغ المجموعة',
      value: <SAR amount={profile.totalRaised} iconSize={16} />,
      icon: 'ri-money-dollar-circle-line',
      color: 'bg-emerald-50 text-emerald-600',
      change: '+12% هذا الشهر',
      changeUp: true,
    },
    {
      label: 'إجمالي الداعمين',
      value: fmt(profile.totalDonors),
      icon: 'ri-user-heart-line',
      color: 'bg-amber-50 text-amber-600',
      change: '+24 هذا الأسبوع',
      changeUp: true,
    },
    {
      label: 'الحملات النشطة',
      value: String(profile.activeCampaigns),
      icon: 'ri-megaphone-line',
      color: 'bg-rose-50 text-rose-500',
      change: `${profile.completedCampaigns} مكتملة`,
      changeUp: null,
    },
    {
      label: 'في انتظار السحب',
      value: <SAR amount={profile.pendingWithdrawal} iconSize={16} />,
      icon: 'ri-bank-line',
      color: 'bg-violet-50 text-violet-600',
      change: 'متاح للسحب الآن',
      changeUp: null,
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white rounded-2xl border border-stone-100 p-4 md:p-5">
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${card.color}`}>
              <i className={`${card.icon} text-lg`}></i>
            </div>
          </div>
          <div className="text-xl md:text-2xl font-black text-stone-800 mb-1">{card.value}</div>
          <div className="text-xs text-stone-400 mb-2 leading-tight">{card.label}</div>
          <div className={`text-xs font-medium flex items-center gap-1 ${
            card.changeUp === true ? 'text-emerald-600' :
            card.changeUp === false ? 'text-red-500' : 'text-stone-400'
          }`}>
            {card.changeUp === true && <i className="ri-arrow-up-line text-xs"></i>}
            {card.changeUp === false && <i className="ri-arrow-down-line text-xs"></i>}
            {card.change}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;
